export interface Permission {
	name: string;
	key?: string;
	includes?: Permission[];
}

export interface Role {
	text: string;
	id: string;
	includes?: Permission[];
}

export const permissionGroups: { [groupName: string]: string[] } = {
	"Project": [
		"EDIT_PROJECT",
		"DELETE_PROJECT",
		"TRANSFER_PROJECT"
	],
	"Users": [
		"USER_DATA",
		"BAN_USERS",
		"UNBAN_USERS",
		"USER_STATUS_BY_ID",
		"WHITELIST_USERS",
		"UNWHITELIST_USERS"
	],
	"Access Codes": [
		"NEW_ACCESS_CODES",
		"MANAGE_ACCESS_CODES",
		"ROLLBACK_ACCESS_CODES"
	],
	"Bot": [
		"BOT_BROADCAST",
		"CHANGE_BOT_TOKEN",
		"CHANGE_BOT_LANGUAGE",
		"MANAGE_BOT_COMMANDS"
	],
	"Resources": [
		"ADD_RESOURCES",
		"EDIT_RESOURCES",
		"DELETE_RESOURCES",
		"MANAGE_RESOURCES"
	],
	"Subscription Plans": [
		"EDIT_SUBSCRIPTION_PLANS",
		"CREATE_SUBSCRIPTION_PLANS",
		"DELETE_SUBSCRIPTION_PLANS",
		"MANAGE_SUBSCRIPTION_PLANS",
		"MANAGE_PAYMENT_OPTIONS"
	],
	"Affiliate Program": [
		"AFP_DATA",
		"MANAGE_AFP",
		"AFP_EDIT_SETTINGS",
		"AFP_CREATE_PAYOUTS",
		"AFP_EXECUTE_PAYOUTS",
		"AFP_CANCEL_PAYOUTS",
		"AFP_EDIT_DESCRIPTION",
		"AFP_SET_AFFILIATE"
	]
};
